import { useState, useRef, useEffect } from 'react';

export const useStreaming = () => {
  const [enableStreaming, setEnableStreaming] = useState(true);
  const [streamingText, setStreamingText] = useState('');
  const [rawStreamText, setRawStreamText] = useState('');
  const [isStreaming, setIsStreaming] = useState(false);
  const streamContainerRef = useRef<HTMLDivElement>(null);
  const rawStreamTextRef = useRef('');

  // Real-time streaming. Unconditional sync: gating on isStreaming dropped
  // the final chunk when the last setRawStreamText batched together with
  // setIsStreaming(false) — the live preview ended cut off mid-word.
  useEffect(() => {
    setStreamingText(rawStreamText);
  }, [rawStreamText]);

  // Auto-scroll during streaming (plan 5.3b, anty-migotanie W3):
  // - scroll NATYCHMIASTOWY (bez behavior:'smooth' — kolejkowane animacje
  //   scrolla co chunk walczyły ze sobą i dawały szarpanie),
  // - TYLKO gdy użytkownik jest „przyklejony" do dołu. Stan przyklejenia
  //   mierzymy względem scrollHeight sprzed bieżącego appendu (efekt biegnie
  //   już PO doklejeniu chunku, więc poprzednią wysokość trzyma ref):
  //   scrollTop + clientHeight >= prevScrollHeight - 40. Ręczne odscrollowanie
  //   wyłącza follow, powrót na dół (w obrębie progu) włącza go z powrotem.
  const lastScrollHeightRef = useRef(0);
  useEffect(() => {
    const el = streamContainerRef.current;
    if (!isStreaming || !el) {
      lastScrollHeightRef.current = 0;
      return;
    }
    const prevScrollHeight = lastScrollHeightRef.current;
    const pinnedToBottom =
      prevScrollHeight === 0 ||
      el.scrollTop + el.clientHeight >= prevScrollHeight - 40;
    if (pinnedToBottom) {
      el.scrollTop = el.scrollHeight;
    }
    lastScrollHeightRef.current = el.scrollHeight;
  }, [streamingText, isStreaming]);

  // NOTE: stream-recovery persistence is consolidated under the single
  // 'wiscv-partial-stream' sessionStorage key owned by useAIIntegration
  // (the legacy duplicate auto-save mechanism was removed in wave 2c).

  return {
    enableStreaming,
    streamingText,
    rawStreamText,
    isStreaming,
    streamContainerRef,
    rawStreamTextRef,
    setEnableStreaming,
    setStreamingText,
    setRawStreamText,
    setIsStreaming
  };
};
